import { Type } from 'app/constants/TourPoints';
import * as e from 'app/constants/TourBuilderEvents';
import * as way from 'app/libs/core/PubSubWays';
import { publish } from 'app/libs/core/PubSub';
import { useMediator } from '../useMediator';

import { tourPoint } from '../../../../../libs/map/drive/TourPoint';

const multiData = () => {
  let partsList = {};
  let pointsList = {};

  const [getMediator, setMediator, destroyMediator] = useMediator();

  const getCountParts = () => Object.keys(partsList).length;

  const getPartByKey = (key) => partsList[key];

  const isPartExists = (key) => partsList[key];

  const showPartPointOnMap = (point) =>
    getMediator().notify(e.ATP_CREATE_POINT_ON_MAP, point);

  const addNewPoint = (point, isLast) => {
    const customId = point.id;
    pointsList[customId] = point;
    showPartPointOnMap({ ...point, isLast });
  };

  const addPointToPart = (point, isEnd) => {
    const key = point.partId;
    if (!isPartExists(key)) partsList[key] = [];
    partsList[key].push(point);
    addNewPoint(point, isEnd);
  };

  const getPageKeyByPointId = (id) =>
    pointsList[id] ? pointsList[id].partId : 0;

  const getPartByPointId = (id) => {
    const key = getPageKeyByPointId(id);
    return getPartByKey(key);
  };

  const getPointById = (id) => pointsList[id];

  const getFirstPointByPartId = (partId) => {
    for (const key in pointsList) {
      if (
        pointsList[key].partId === partId &&
        pointsList[key].type === Type.START
      )
        return { ...pointsList[key] };
    }
    return {};
  };

  const getLastPointByPartId = (partId) => {
    for (const key in pointsList) {
      if (
        pointsList[key].partId === partId &&
        pointsList[key].type === Type.END
      )
        return { ...pointsList[key] };
    }
    return {};
  };

  const upPointData = (data) => {
    const { id, lat, lng } = data;
    const point = tourPoint({ ...getPointById(id), isNotStickedToRoad: true });
    point.lat = lat;
    point.lng = lng;
    return { ...point };
  };

  const clearMultiData = () => {
    partsList = {};
    pointsList = {};
    publish(way.DRIVE_BUILDER_DATA_CLEAN, {});
  };

  const destroy = () => {
    clearMultiData();
    destroyMediator();
  };

  return Object.freeze({
    setMediator,
    clearMultiData,
    destroy,
    getCountParts,
    addPointToPart,
    getPageKeyByPointId,
    getPointById,
    upPointData,
    getPartByKey,
    getPartByPointId,
    getFirstPointByPartId,
    getLastPointByPartId,
  });
};

export default multiData;
